import axios from 'axios'
import BaseService from './base'

export default class DocumentService extends BaseService {
    uploadDocument (form) {
        return axios.post(`${this.host}/documents/`, form)
    }
}
